import { render, staticRenderFns } from "./statView.vue?vue&type=template&id=6cbd510a&"
import script from "./statView.vue?vue&type=script&lang=js&"
export * from "./statView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports